function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M47.158 32.99l-2.436-7.234h1.072l2.239 6.676h-.542l2.322-6.676h.958l2.27 6.676h-.521l2.27-6.676h.988l-2.436 7.234H52.25l-2.124-6.19h.281l-2.134 6.19h-1.114zm11.674-4.113h3.748v.878h-3.748v-.878zm.094 3.214h4.248v.9h-5.289v-7.235h5.143v.899h-4.102v5.436zm5.663.9l3.3-7.235h1.03l3.312 7.234h-1.093l-2.947-6.656h.417L65.66 32.99H64.59zm1.405-1.81l.281-.826h4.102l.303.827h-4.686zm8.157 1.81v-7.235h1.04v6.335h3.947v.9H74.15zm7.78 0v-6.336h-2.498v-.9h6.028v.9h-2.499v6.335h-1.03zm10.723-7.235h1.041v7.234h-1.04v-7.234zM88.47 32.99h-1.041v-7.234h1.04v7.234zm4.279-3.224h-4.383v-.9h4.383v.9z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.666 9.695v22.73h4.713v-3.854h1.202c1.857 0 3.752-.082 5.483-.743 10.658-4.07 6.337-18.133-2.691-18.133h-8.707zm4.713 14.55V13.943h3.994c3.937 0 6.51 7.701.988 9.979-.636.262-1.337.325-2.026.325h-2.956z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.325 9.713H5.72v13.148c0 13.399 19.961 13.477 19.961 0V9.713h-4.768v13.148c0 5.15-4.258 5.411-5.136 5.41-.107 0-.208-.005-.314-.015-.877-.085-5.137-.736-5.137-5.395V9.713zM95.621 25.322V23.8h-.606v-.216h1.462v.216h-.606v1.52h-.25zm1.03 0v-1.737h.208l.793 1.312h-.111l.783-1.312h.207l.003 1.736h-.243l-.002-1.361h.058l-.698 1.15h-.116l-.702-1.15h.063v1.361h-.242z",
  fill: "#000"
});

function SvgLogoExtended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 45,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLogoExtended;